import omit from 'lodash/omit'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { useLocation, useNavigate } from 'react-router-dom'
import LandingPageTemplateForm from './LandingPageTemplateForm'
import usePermissions from '@/hooks/usePermissions'
import Redirect from '@/components/Redirect'

const mapStateToProps = () => ({})

const LandingPageTemplateEdit = ({ dispatch }) => {
  const { t } = useTranslation()
  const [labelList, setLabelList] = useState([])
  const [html, setHtml] = useState('')
  const [extendResponse, setExtendResponse] = useState({})

  const navigate = useNavigate()
  const { state } = useLocation()
  // refLandingpage is refLandingpageId here
  const { landingpageTempId, type } = state || {}
  const canModify = usePermissions(
    type === 'system' ? 'landingpageSystem_modify' : 'landingpagePerson_modify',
  )

  const formData = {
    landingpageTempId,
    labelNameList: labelList,
    content: html,
    ...extendResponse,
  }

  useEffect(() => {
    dispatch({
      type: 'landingPage/getLandingPageLabelsById',
      payload: { landingpageTempId },
      successCallback: options => {
        const transformedOptions = options?.map(({ landingpageLabelId, labelName }) => ({
          id: landingpageLabelId,
          label: labelName,
        }))
        if (transformedOptions) {
          setLabelList(transformedOptions)
        }
      },
    })

    dispatch({
      type: 'landingPage/getLandingPageById',
      payload: { landingpageTempId },
      successCallback: response => {
        const { refLandingpage, refLandingpageName, name, htmlTitle, htmlContent } = response
        setHtml(htmlContent)
        let extractResponse = { name, htmlTitle }
        if (refLandingpage) {
          extractResponse = {
            ...extractResponse,
            refLandingpageId: refLandingpage,
            refLandingpageName,
            isRefLandingPage: true,
          }
        } else {
          extractResponse = {
            ...extractResponse,
            refLandingpageId: null,
            refLandingpageName: null,
            isRefLandingPage: false,
          }
        }
        setExtendResponse(extractResponse)
      },
    })
  }, [dispatch, landingpageTempId])

  const onSubmit = payload => {
    const transformPayload = omit(payload, 'type')

    dispatch({
      type: 'landingPage/editLandingPage',
      payload: { ...transformPayload, landingpageTempId },
      successCallback: () => {
        dispatch({
          type: 'app/notify',
          payload: { message: t('messages.landing_template_updated'), severity: 'success' },
        })
        navigate(`/phish_template_landing/${type || 'system'}`, { replace: true })
      },
    })
  }

  if (!canModify) return <Redirect />
  
  return <LandingPageTemplateForm onSubmit={onSubmit} data={formData} type={type} />
}

export default connect(mapStateToProps)(LandingPageTemplateEdit)
